<template>
    <b-card>
        <b-card-header>Sök efter bokningar </b-card-header>
        <b-card-body>
            <b-row>
                <b-col>
                    Sök bokningar som innehåller en eller flera sökbegrepp. Observera att andra filtreringar i aktuell vy
                    fortfarande är aktiva.
                </b-col>
            </b-row>
            <b-row>
                <b-col v-for="st in searchType" :key="st.type">
                    <b-button :variant="(isCurrType(st)) ? 'secondary' : 'light'" @click="setSearchType(st)">
                        {{ st.name }}</b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-textarea autofocus v-model="searchFor" rows="10" placeholder="Ange sökbegrepp..."
                        @change="onchange()"></b-textarea>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-button variant="outline" @click="searchFor = null; onchange()">
                        <b-icon-x-circle-fill></b-icon-x-circle-fill> Töm filter
                    </b-button>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>
<script>
export default {
    name: 'fastfindbookings',
    props: ['value'],
    data() {
        return {
            searchType: [{ "name": "KolliId", "type": "COLLIID" }, { "name": "Ordernummer", "type": "ORDERNO" }, { "name": "Fraktsedelsnummer", "type": "TSPDOCNO" }],
            searchFor: null,
            currSearchType: null
        }
    },
    created() {
        if (this.value) {
            this.currSearchType = this.getSearchTypeByName(this.value.type);
            this.searchFor = this.value.searchFor;
        }
        if(!this.currSearchType)
            this.currSearchType = this.searchType[0];        
    },
    methods: {
        onchange() {
            this.$emit('change', { searchFor: this.searchFor, type: this.currSearchType.type });
        },
        setSearchType(st) {
            this.currSearchType = st;
            this.onchange();
        },
        isCurrType(st) {
            if(this.currSearchType)
                if(this.currSearchType.type)
                    return st.type.toUpperCase()==this.currSearchType.type.toUpperCase();
                
            return false;
        },
        getSearchTypeByName(stName) {
            return this.searchType.find(x=>x.type == stName);
        }
    }
}
</script>